module.exports = __webpack_public_path__ + "img/7-ilpakamanioMAS_thumb.a1b4be7f.jpg";